import API from "./api";

const BACKUP_KEY = "fixli_admin_token_backup";
const REFRESH_BACKUP_KEY = "fixli_admin_refresh_backup";
const FLAG_KEY = "fixli_impersonation";

export function isImpersonating() {
  return !!localStorage.getItem(FLAG_KEY);
}

export async function startImpersonation(tenant, reason = "") {
  const { data } = await API.post(`/tenants/${tenant.id}/impersonate`, { reason });
  localStorage.setItem(BACKUP_KEY, localStorage.getItem("access_token") || "");
  localStorage.setItem(REFRESH_BACKUP_KEY, localStorage.getItem("refresh_token") || "");
  localStorage.removeItem("refresh_token"); // support tokens never silently renew past their 60 min
  localStorage.setItem("access_token", data.access_token);
  localStorage.setItem(FLAG_KEY, JSON.stringify({ tenant_id: tenant.id, tenant_name: tenant.name, expires_at: data.session?.expires_at }));
  localStorage.removeItem("fixli_tenant_testing_mode");
  window.location.href = "/";
}

export async function exitImpersonation() {
  try { await API.post("/auth/impersonation/exit"); } catch {}
  restoreAdminSession();
  window.location.href = "/platform/tenants";
}

export function restoreAdminSession() {
  const backup = localStorage.getItem(BACKUP_KEY);
  const refreshBackup = localStorage.getItem(REFRESH_BACKUP_KEY);
  if (backup) localStorage.setItem("access_token", backup);
  if (refreshBackup) localStorage.setItem("refresh_token", refreshBackup);
  localStorage.removeItem(BACKUP_KEY);
  localStorage.removeItem(REFRESH_BACKUP_KEY);
  localStorage.removeItem(FLAG_KEY);
}
